module.exports = __webpack_public_path__ + "img/entities-view.a3a76c7d.svg";